<div>
    <canvas baseChart
        [labels]="doughnutChartLabels"
        [datasets]="doughnutChartDatasets"
        [options]="doughnutChartOptions"
        [legend]="true"
        [type]="'doughnut'"> 
 </canvas>
<div class="progressTxt">
    <span>{{progressText}}</span>
</div>
</div>
